export default __webpack_public_path__ + "static/media/servicii-copii-1.467a56ab.png";